import React, {PureComponent} from "react"
import PropTypes from "prop-types"
import {Col} from "@irati/ui/src/Layout"
import {get, isEmpty} from "lodash"
import moment from "moment"

import withBranding from "@irati/brand/withBranding"
import {FormattedMessage} from "@irati/utils/lang"
import {determineDealThumbnailImage} from "@irati/deals/helpers/deals/appearance"
import {Body, H4} from "@irati/ui/src/Typography"

import {shouldDisplayDealAvatar} from "../../utils/deals/imageUtils"
import {DealAvatar} from "./styled/MyPerksItem"
import {StyledDiv, StyledRow, LogoWrapper, MobileQty} from "./styled/SelectedPerkDetails"

class SelectedPerkDetails extends PureComponent {
  static propTypes = {
    redemption: PropTypes.object.isRequired,
    branding: PropTypes.object.isRequired
  }

  render() {
    const {redemption, branding} = this.props
    const orderProducts = redemption?.order?.products || []
    const quantity = orderProducts?.reduce((acc, product) => acc + product.items.length, 0)
    const thumbnailImage = shouldDisplayDealAvatar(redemption.dealSnapshot)
      ? determineDealThumbnailImage(redemption.dealSnapshot, branding)
      : null

    return (
      <StyledDiv>
        <StyledRow key={redemption.uuid}>
          {thumbnailImage && (
            <Col xs={3} sm={3}>
              <LogoWrapper>
                <DealAvatar src={thumbnailImage} alt={get(redemption, "dealSnapshot.header", "placeholder image")} />
              </LogoWrapper>
            </Col>
          )}
          <Col xs={9} sm={9}>
            <StyledRow>
              <Col xs={6} sm={6}>
                <H4 overflowWrap="break-word">{get(redemption, "dealSnapshot.header", "This is a deal header")}</H4>
              </Col>
              <Col xsHidden sm={3}>
                {!isEmpty(orderProducts) && (
                  <Body small textAlign="right">
                    {quantity > 0 && `x ${quantity}`}
                  </Body>
                )}
              </Col>
              <Col xs={6} sm={3}>
                <div className="pull-right">
                  {quantity > 0 && (
                    <MobileQty small>
                      <FormattedMessage id="perks.components.myPerks.myPerksItem.quantity" values={{quantity}} />
                    </MobileQty>
                  )}
                  <Body small>{moment.unix(redemption.dateUnix).format("DD/MM/YY")}</Body>
                </div>
              </Col>
            </StyledRow>
          </Col>
        </StyledRow>
      </StyledDiv>
    )
  }
}

export default withBranding(SelectedPerkDetails)
